import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
export default function AboutMinting() {
  const $ = _c(100);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Minting Meme Cards</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p><b>Summary</b></p>;
    t2 = <li>Meme Cards are minted (primary sale) when the art for the next Meme Card is ready</li>;
    t3 = <br />;
    t4 = <li>Currently, this is about 3 times per week, but the frequency has varied in the past and will vary in the future</li>;
    t5 = <br />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t10;
  let t11;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <li>The minting website for The Memes is:{" "}<Link href="/the-memes/mint">https://6529.io/the-memes/mint</Link></li>;
    t7 = <br />;
    t8 = <li>There is no other minting website for The Memes</li>;
    t9 = <br />;
    t10 = <li>The current minting price is 0.06529ETH + gas costs</li>;
    t11 = <br />;
    $[6] = t10;
    $[7] = t11;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[6];
    t11 = $[7];
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t12;
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <li>Minting time and dates are announced on{" "}<a href="https://x.com/6529collections" target="_blank" rel="noopener noreferrer">https://x.com/6529collections</a></li>;
    t13 = <br />;
    $[12] = t12;
    $[13] = t13;
  } else {
    t12 = $[12];
    t13 = $[13];
  }
  let t14;
  let t15;
  let t16;
  let t17;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <li>Currently, the mints are happening Mon/Wed/Fri at 11am ET (4pm UTC), but times may vary. Please follow @<a href="https://x.com/6529collections" target="_blank" rel="noopener noreferrer">6529collections</a>{" "}for details</li>;
    t15 = <br />;
    t16 = <li>The Memes generally mint using an allowlist model. The purpose of the allowlist is to avoid gas wars / bot wars and to give as broad a range of people as possible a chance to mint.</li>;
    t17 = <br />;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
  } else {
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  let t19;
  let t20;
  let t21;
  let t22;
  let t23;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ul>{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}<li>A collector of one or more The Memes NFT should not assume they receive an allowlist spot for multiple reasons:<ul><br /><li>There are many more collectors of The Memes NFTs than there are allowlist spots.</li><br /><li>The allowlist approach is constantly changing and may, in the future, move to a completely different model, if a better approach emerges.</li><br /><li>Buy The Memes that you like, because you like holding the art or feel a sense of identity with the mission. Do not buy them for an allowlist spot.</li></ul></li><br /><li>There is quite a bit of thought that goes into the allowlist process. Read below to learn more.</li></ul>;
    t19 = <br />;
    t20 = <p><b>Philosophy of The Memes Minting</b></p>;
    t21 = <ul><li>Mints for well-known collections where demand may exceed supply are very difficult to manage effectively. The main approaches and our views on them are highlighted below.</li><br /><li>Public Mints: Public unrestricted mints will be won by a small number of parties using bots and paying high gas fees. We have rejected this approach because it is obviously a terrible idea.</li><br /><li>Raise Prices (either directly or through auctions): The benefit of higher prices is that they help avoid gas wars and return much more money to the artists and creators. The downside is that it makes the project accessible only to wealthy collectors. We do not want The Memes to be accessible only to wealthy collectors, so we have rejected this approach too.</li><br /><li>Allowlists: Allowlists work on a technical basis by restricting which addresses can mint on primary. Gas wars can be avoided (mostly) by correctly predicting how many addresses to allowlist relative to the edition size. One can also maintain low primary prices with this model. This is the model we feel is most suitable for the project mission of The Memes.</li><br /><li>Open Editions: Open editions absorb all demand by having unlimited size editions. This is an intriguing and relevant model for The Memes. Our current approach is to use this model approximately once per SZN. The cultural factors in the NFT space generally appear to preclude against ongoing use of Open Editions, and most artists are not comfortable with open editions (they prefer to use their "one" or "occasional" Open Edition for themselves).</li></ul>;
    t22 = <br />;
    t23 = <p><b>Allowlists At The Memes: Background</b></p>;
    $[18] = t18;
    $[19] = t19;
    $[20] = t20;
    $[21] = t21;
    $[22] = t22;
    $[23] = t23;
  } else {
    t18 = $[18];
    t19 = $[19];
    t20 = $[20];
    t21 = $[21];
    t22 = $[22];
    t23 = $[23];
  }
  let t24;
  let t25;
  let t26;
  let t27;
  let t28;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <br />;
    t25 = <li>Imagine The Memes are a gallery in a big warehouse somewhere in New York, that is the gathering point for a group of collectors and artists who share a common ideological interest in art and decentralization</li>;
    t26 = <br />;
    t27 = <li>A few times a week, an artist in the collective produces an edition of hopefully attractive, definitely ideological, art that is put up for sale at a hopefully attractive price</li>;
    t28 = <br />;
    $[24] = t24;
    $[25] = t25;
    $[26] = t26;
    $[27] = t27;
    $[28] = t28;
  } else {
    t24 = $[24];
    t25 = $[25];
    t26 = $[26];
    t27 = $[27];
    t28 = $[28];
  }
  let t29;
  let t30;
  let t31;
  let t32;
  let t33;
  let t34;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <li>The purpose of the allowlist is "<i>who should we invite that night to have an opportunity to buy the editions first?</i>"</li>;
    t30 = <br />;
    t31 = <li>The classic answer in the physical world is friends of the gallery, friends of the artists, repeat collectors of the gallery and maybe some random people to keep it interesting and introduce new people to the mix</li>;
    t32 = <br />;
    t33 = <li>The answer here is broadly similar, but with two differences: the scale is sometimes larger and people can pretend to be more than 1 person by having different Ethereum addresses</li>;
    t34 = <br />;
    $[29] = t29;
    $[30] = t30;
    $[31] = t31;
    $[32] = t32;
    $[33] = t33;
    $[34] = t34;
  } else {
    t29 = $[29];
    t30 = $[30];
    t31 = $[31];
    t32 = $[32];
    t33 = $[33];
    t34 = $[34];
  }
  let t35;
  let t36;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <li>It might be useful to understand how we imagine the allowlist process. The analogy below is imperfect, but still helpful.<ul>{t24}{t25}{t26}{t27}{t28}{t29}{t30}{t31}{t32}{t33}{t34}<li>In technical terms, identity on Ethereum is vulnerable to Sybil attacks. As Wikipedia states: "<i>A Sybil attack is a type of attack on a computer network service in which an attacker subverts the service's reputation by creating a large number of pseudonymous identities and uses them to gain a disproportionally large influence</i>"</li><br /><li>The purpose of Bitcoin mining's proof of work algorithm is, in some ways, to prevent Sybil attacks vs other consensus mechanisms that do not protect against them</li></ul></li>;
    t36 = <br />;
    $[35] = t35;
    $[36] = t36;
  } else {
    t35 = $[35];
    t36 = $[36];
  }
  let t37;
  let t38;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <li>With that as background, what did we do first?<ul><br /><li>For the initial The Memes mints, we allowlisted hundreds of people by hand</li><br /><li>We fought the "Sybil attack" by individually going to people we knew were real people and allowlisting them for the initial mints</li><br /><li>It was a tedious process, and I am not sure any other meaningful collection has started that way</li><br /><li>What we "earned" in return, however, is a base of "real people" and editions that are extraordinarily well distributed. On most Memes cards, unique ownership percentages are in the 70-80% range or 80% to 90% if you exclude our internal holdings</li></ul></li>;
    t38 = <br />;
    $[37] = t37;
    $[38] = t38;
  } else {
    t37 = $[37];
    t38 = $[38];
  }
  let t39;
  let t40;
  let t41;
  let t42;
  let t43;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <ul>{t35}{t36}{t37}{t38}<li>Once we had manually established a base of real people, we allowlisted them for future mints. In the beginning, this was straightforward.<ul><br /><li>Demand was relatively low and the mints took time to mint out</li><br /><li>We were even able to sprinkle in a public mint here or there</li><br /><li>Over time, however, there was more demand for The Memes and the allowlists become more challenging to create</li></ul></li></ul>;
    t40 = <br />;
    t41 = <p><b>Allowlists At The Memes: Current Practices</b></p>;
    t42 = <li>This is the current process for allowlists at The Memes as of February 2023. It is certain that the process will change in the future, as it has in the past, in response to new challenges.</li>;
    t43 = <br />;
    $[39] = t39;
    $[40] = t40;
    $[41] = t41;
    $[42] = t42;
    $[43] = t43;
  } else {
    t39 = $[39];
    t40 = $[40];
    t41 = $[41];
    t42 = $[42];
    t43 = $[43];
  }
  let t44;
  let t45;
  let t46;
  let t47;
  let t48;
  let t49;
  let t50;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <br />;
    t45 = <li>The 6529 Museum</li>;
    t46 = <br />;
    t47 = <li>Various individuals working on the project and the 6529 Fund</li>;
    t48 = <br />;
    t49 = <li>The artist or artists who worked on that Meme</li>;
    t50 = <br />;
    $[44] = t44;
    $[45] = t45;
    $[46] = t46;
    $[47] = t47;
    $[48] = t48;
    $[49] = t49;
    $[50] = t50;
  } else {
    t44 = $[44];
    t45 = $[45];
    t46 = $[46];
    t47 = $[47];
    t48 = $[48];
    t49 = $[49];
    t50 = $[50];
  }
  let t51;
  let t52;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t51 = <li>The process begins with automatic airdrops to:<ul>{t44}{t45}{t46}{t47}{t48}{t49}{t50}<li>These are the parties that are "<i>always on the guest list</i>"</li></ul></li>;
    t52 = <br />;
    $[51] = t51;
    $[52] = t52;
  } else {
    t51 = $[51];
    t52 = $[52];
  }
  let t53;
  let t54;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <li>The second part of the process is a few "partial" airdrops to:<ul><br /><li>Collectors of Meme Card or Gradients</li><br /><li>Collectors of the artist</li><br /><li>The purpose of the partial airdrops is to give a chance to acquire a Meme Card to community members who are not always online and available to mint.</li></ul></li>;
    t54 = <br />;
    $[53] = t53;
    $[54] = t54;
  } else {
    t53 = $[53];
    t54 = $[54];
  }
  let t55;
  let t56;
  let t57;
  let t58;
  let t59;
  let t60;
  let t61;
  let t62;
  let t63;
  let t64;
  let t65;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <br />;
    t56 = <li>In Phase I, we try to guess how many people to allowlist relative to the number of available cards for minting</li>;
    t57 = <br />;
    t58 = <li>The perfect guess would mean that Phase I mints out, within its 30 minute window, without having a gas war</li>;
    t59 = <br />;
    t60 = <li>If we overestimate the number of people to allowlist, there is a gas war</li>;
    t61 = <br />;
    t62 = <li>If we underestimate, we go to Phase II which is a continuation of the Phase I logic, but to a broader set of participants. Phase III is the public mint</li>;
    t63 = <br />;
    t64 = <li>It is impossible to get this precisely right because likelihood to mint varies by different groups, particularly the artist's collectors. We are happy if we are 80% correct, 80% of the time</li>;
    t65 = <br />;
    $[55] = t55;
    $[56] = t56;
    $[57] = t57;
    $[58] = t58;
    $[59] = t59;
    $[60] = t60;
    $[61] = t61;
    $[62] = t62;
    $[63] = t63;
    $[64] = t64;
    $[65] = t65;
  } else {
    t55 = $[55];
    t56 = $[56];
    t57 = $[57];
    t58 = $[58];
    t59 = $[59];
    t60 = $[60];
    t61 = $[61];
    t62 = $[62];
    t63 = $[63];
    t64 = $[64];
    t65 = $[65];
  }
  let t66;
  let t67;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t66 = <li>Our general approach is to allowlist:<ul><br /><li>Some of the "larger" Meme Card collectors with a focus on "large" being "number of different cards held", as opposed to "total cards held"</li><ul><br /><li>The limit case of "number of different cards held" is "full set collectors"</li><br /><li>We prefer "number of different cards held" to "total cards held" because getting different cards in individual's wallets where they can be seen by others is more important than getting duplicates of the same card in wallets</li><br /><li>Total cards held or total days held can be used as a tie-breaker though</li></ul><br /><li>Some or all of the Gradient collectors</li><br /><li>Some or all of the artist's collectors</li><br /><li>A few people not in the above categories</li></ul></li>;
    t67 = <br />;
    $[66] = t66;
    $[67] = t67;
  } else {
    t66 = $[66];
    t67 = $[67];
  }
  let t68;
  let t69;
  if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
    t68 = <li>The third part of the process is the Phase I mint.<ul>{t55}{t56}{t57}{t58}{t59}{t60}{t61}{t62}{t63}{t64}{t65}{t66}{t67}<li>Why do we allowlist these categories?<ul><br /><li>We often allowlist the larger collectors not only because they tend to be bigger supporters of the gallery, but also because, if we did not, they would split their cards into separate wallets and appear to be more numerous smaller collectors</li><br /><li>We often allowlist the Gradient collectors because they were early supporters of the vision</li><br /><li>We always allowlist the artist's collectors because, of course, the artist should allowlist their own collectors, and also because this is an important mechanism to introduce new collectors to The Memes</li><br /><li>We have allowlisted collectors of over hundreds, possibly thousands, of collections so far. It is hugely important to the project mission and we intend to continue to do this</li><br /><li>We allowlist some other random categories so that there is some diversity in the minters</li></ul></li><br /><li>Having said all that, we also sometimes deviate from this approach to improve the diversity of collectors. How often we can deviate from that before the large collectors split their wallets is a challenging question.</li></ul></li>;
    t69 = <br />;
    $[68] = t68;
    $[69] = t69;
  } else {
    t68 = $[68];
    t69 = $[69];
  }
  let t70;
  let t71;
  let t72;
  let t73;
  let t74;
  let t75;
  let t76;
  if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
    t70 = <ul>{t42}{t43}{t51}{t52}{t53}{t54}{t68}{t69}<li>It is important to emphasize that you see the allowlist in the same light in which we see it, namely, that it is something like a guest list for a gallery.<ul><br /><li>If you were a large collector of Andy Warhols from an important New York gallery, sure, it is normal to expect that you might be invited to their cocktail parties or to get an early look at new work in the gallery</li><br /><li>You would not, however, collect Andy Warhols primarily to receive cocktail party invites and you would understand that you did not always get an early look at all new pieces in the gallery</li></ul></li></ul>;
    t71 = <br />;
    t72 = <p><b>Provability</b></p>;
    t73 = <li>We take a series of measures to prove that the allowlists are created the way we say they are created.</li>;
    t74 = <br />;
    t75 = <li>This is a level of diligence and transparency that has no real physical world equivalent. A gallery would not open up their records to the guests at the event to explain how and who was invited. One of the powers of public blockchains is that we can offer this transparency, so we do so.</li>;
    t76 = <br />;
    $[70] = t70;
    $[71] = t71;
    $[72] = t72;
    $[73] = t73;
    $[74] = t74;
    $[75] = t75;
    $[76] = t76;
  } else {
    t70 = $[70];
    t71 = $[71];
    t72 = $[72];
    t73 = $[73];
    t74 = $[74];
    t75 = $[75];
    t76 = $[76];
  }
  let t77;
  let t78;
  let t79;
  let t80;
  let t81;
  let t82;
  let t83;
  let t84;
  let t85;
  let t86;
  let t87;
  let t88;
  let t89;
  if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
    t77 = <ul>{t73}{t74}{t75}{t76}<li>In particular, we do the following:<ul><br /><li>We announce in advance on which Ethereum block we will snapshot the collectors of The Memes, the Gradients and the artist's NFTs</li><br /><li>We announce a block from which we will draw pseudorandomness</li><br /><li>It is important for this to work that the blocks are announced publicly before they happen</li><br /><li>We post our allowlist formula and calculations on github</li><br /><li>Anyone with a bit of technical savvy can replicate how we created the allowlist</li><br /><li>This process does not mean the allowlist is predictable. It just confirms that the allowlist is what we say it is.</li></ul></li></ul>;
    t78 = <br />;
    t79 = <p><b>Improvements</b></p>;
    t80 = <li>We think there are areas that can be improved in the allowlist approach to make it richer at capturing different variables.</li>;
    t81 = <br />;
    t82 = <li>In February, we hope to roll out a metric called "TDH" - Total Days Held, a metric that derives from the old Bitcoin metric of Total Days Destroyed.</li>;
    t83 = <br />;
    t84 = <li>It is a metric of how long The Memes have been held by an address and it adds another useful data point. There may be times when someone may want to differentiate between a collector who has held 10 cards for 1 year vs a collector who has held 10 cards for 1 day. As with all metrics, TDH is not going to be used in a fixed way. It is another tool in the toolkit and metrics we are making available.</li>;
    t85 = <br />;
    t86 = <li>We would like to find a way to capture social factors in the metrics. Who is contributing in Discord, who is creating ReMemes, who is generally helpful to the mission? In the physical world these factors would definitely be taken into account. The challenge here is how to do this in a decentralized and transparent way.</li>;
    t87 = <br />;
    t88 = <li>We would like to find a way to categorize the collectors based on their actions. These might be useful factors in future allowlists.</li>;
    t89 = <br />;
    $[77] = t77;
    $[78] = t78;
    $[79] = t79;
    $[80] = t80;
    $[81] = t81;
    $[82] = t82;
    $[83] = t83;
    $[84] = t84;
    $[85] = t85;
    $[86] = t86;
    $[87] = t87;
    $[88] = t88;
    $[89] = t89;
  } else {
    t77 = $[77];
    t78 = $[78];
    t79 = $[79];
    t80 = $[80];
    t81 = $[81];
    t82 = $[82];
    t83 = $[83];
    t84 = $[84];
    t85 = $[85];
    t86 = $[86];
    t87 = $[87];
    t88 = $[88];
    t89 = $[89];
  }
  let t90;
  let t91;
  let t92;
  let t93;
  let t94;
  let t95;
  let t96;
  let t97;
  let t98;
  if ($[90] === Symbol.for("react.memo_cache_sentinel")) {
    t90 = <ul>{t80}{t81}{t82}{t83}{t84}{t85}{t86}{t87}{t88}{t89}<li>For our full analysis of our Network Definitions, go here:{" "}<Link href="/network/definitions" target="_blank" rel="noopener noreferrer">6529.io/network/definitions</Link></li></ul>;
    t91 = <br />;
    t92 = <p><b>Tools</b></p>;
    t93 = <li>One of our mental models is that NFTs are publicly readable databases of people with common interests.</li>;
    t94 = <br />;
    t95 = <li>Given this, we hope that the publicly readable database of The Memes collectors will be used by many other people to make their own guest lists - for Meme Labs, for ReMemes, for all types of things we can and can't imagine.</li>;
    t96 = <br />;
    t97 = <li>In order to support this, we are going to progressively make our tools for allowlists available to everyone (whether Meme Card collectors or not).</li>;
    t98 = <br />;
    $[90] = t90;
    $[91] = t91;
    $[92] = t92;
    $[93] = t93;
    $[94] = t94;
    $[95] = t95;
    $[96] = t96;
    $[97] = t97;
    $[98] = t98;
  } else {
    t90 = $[90];
    t91 = $[91];
    t92 = $[92];
    t93 = $[93];
    t94 = $[94];
    t95 = $[95];
    t96 = $[96];
    t97 = $[97];
    t98 = $[98];
  }
  let t99;
  if ($[99] === Symbol.for("react.memo_cache_sentinel")) {
    t99 = <Container>{t0}<Row className="pt-3 pb-3"><Col>{t1}{t18}{t19}{t20}{t21}{t22}{t23}{t39}{t40}{t41}{t70}{t71}{t72}{t77}{t78}{t79}{t90}{t91}{t92}<ul>{t93}{t94}{t95}{t96}{t97}{t98}<li>On a daily basis, we publish to Arweave the statistics we use to create our own allowlists. You can find them here:{" "}<Link href="/open-data" target="_blank" rel="noopener noreferrer">6529.io/open-data</Link></li><br /><li>Over the next few months, we will also make available our tools for taking snapshots and randomization</li></ul><br /><p><b>Technical Issues</b></p><ul><li>Sometimes under heavy load the minting page will fail to load or fail to load a transaction. You may have to refresh multiple times to be successful in minting.</li><br /><li>Some users have reported that hard-refreshing or clearing their local browser cache between mints may be helpful.</li><br /><li>In highly competitive mints, you may have to put a higher gas price to mint in time. We cannot advise on the correct gas to use as it differs every time.</li><br /><li>In highly competitive mints, you may pay for a transaction that does not mint in time and lose your gas fee. We do not refund gas fees for failed transactions.</li></ul></Col></Row></Container>;
    $[99] = t99;
  } else {
    t99 = $[99];
  }
  return t99;
}